import React, { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useAppSelector } from '~redux/hooks';

import HomeScreen from '~containers/Home';
import Login from '~containers/Auth/Login';

import UtilFunctions from '~utils/functions';
import PrivateRoute from './PrivateRoutes';

const PrivateBucket: FC = () => {
    return (
        <Route
            path='/'
            element={<PrivateRoute />}
        >
            <Route
                path='/'
                element={<HomeScreen />}
            />

            <Route
                path='*'
                element={<Navigate replace to='/' />}
            />
        </Route>
    );
};

const NavRoutes: FC = (props) => {
    const {
        Auth: {
            getAuthToken,
        },
    } = UtilFunctions;

    let isAuthenticated = useAppSelector(state => state.auth.userDetails.authToken);

    if (!isAuthenticated) isAuthenticated = getAuthToken() || '';

    return (
        <Routes>
            {!isAuthenticated && (
                <Route
                    path='/login'
                    element={<Login />}
                />
            )}

            {PrivateBucket(props)}
        </Routes>
    );
};

export default NavRoutes;
